import { InMemoryCache } from "apollo-cache-inmemory";
import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import { ApolloLink } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { shopConfig } from "~/helpers/shopConfig";
import introspectionQueryResultData from "./fragmentTypes.json";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.nexusapp.co/nexus/storefront/graphql"
    : "https://api.nexusapp.test/nexus/storefront/graphql";

export const generateApolloLink = (apiUrl: string) => {
  return ApolloLink.from([
    // Omit typename
    new ApolloLink((operation, forward) => {
      if (operation.variables) {
        operation.variables = JSON.parse(
          JSON.stringify(operation.variables),
          (key, value) => (key === "__typename" ? undefined : value)
        );
      }

      return forward ? forward(operation) : null;
    }),
    new HttpLink({
      headers: { "x-shop-handle": shopConfig.webshop },
      uri: apiUrl
    })
  ]);
};

const client = new ApolloClient({
  cache: new InMemoryCache({ fragmentMatcher }),
  link: generateApolloLink(API_URL)
});

export default client;



// WEBPACK FOOTER //
// ./src/graphql/client.ts